export default "__VITE_ASSET__Ca26bYrI__"